import { createRouter, createWebHistory } from 'vue-router'
import LayoutView from '../views/LayoutView.vue';
import HomeView from '../views/main/Home.vue';
import AboutView from '../views/main/About.vue';
import ServicesView from '../views/main/Services.vue';
import PortfolioView from '../views/main/Portfolio.vue';
import ContactView from '../views/main/Contact.vue';
const routes = [
  {
    path: '/',
    component: LayoutView,
    children:[
      {
        path: "/",
        name: "Inicio",
        components: {default: HomeView}
      },
      {
        path:"sobre",
        name: "Sobre",
        components: { default: AboutView }
      },
      {
        path:"servicios",
        name: "Servicios",
        components: {default: ServicesView}
      },
      {
        path:"portafolio",
        name: "Portafolio",
        components: {default:PortfolioView}
      },
      {
        path:"contacto",
        name: "Contacto",
        components: {default: ContactView}
      },

    ]
  },
  {
    path: '/about',
    name: 'about',
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
